import { useEffect, useState } from "react";
import { Breadcrumb, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import IconArrowBack from "components/Icons/IconArrowBack/IconArrowBack";
import PageHeading from "components/PageHeading/PageHeading";
import TutoringThemes from "features/Themes/Themes";
import { useUserSubjects } from "utils/hooks/useUserSubjects";

const Subjects = () => {
  const { t } = useTranslation(["common", "tutoring"]);

  const { pathname } = useLocation();
  const { userSubjects } = useUserSubjects();
  const [currentSubjectId, setCurrentSubjectId] = useState<string | null>(null);

  // TODO: load slug from subject
  const getSubjectAbbreviationFromSlug = (slug: string) => {
    switch (slug) {
      case "matematika":
        return "M";
      case "cesky-jazyk":
        return "CJ";
      case "anglictina":
        return "AJ";
      default:
        return undefined;
    }
  };

  useEffect(() => {
    const subjectSlug = pathname.split("/").at(-1);
    if (userSubjects === undefined || userSubjects.length === 0 || !subjectSlug) return;

    const currentSubjectAbbreviation = getSubjectAbbreviationFromSlug(subjectSlug);
    if (!currentSubjectAbbreviation) return;

    const currentSubject = userSubjects.find(subject => subject.subject?.abbreviation === currentSubjectAbbreviation);

    setCurrentSubjectId(currentSubject?.subject?.id ?? null);
  }, [userSubjects, pathname]);

  return (
    <>
      <div className="page-header">
        <Container className={"container-mw-md page-container"}>
          <Breadcrumb>
            <li className={"breadcrumb-item"}>
              <Link to={"/"}>
                <IconArrowBack />
                {t("goHome")}
              </Link>
            </li>
          </Breadcrumb>

          <PageHeading className={"mb-8px"} />
        </Container>
      </div>

      <Container className={"container-mw-md page-container"}>
        {currentSubjectId ? <TutoringThemes key={currentSubjectId} subjectId={currentSubjectId} /> : null}
      </Container>
    </>
  );
};

export default Subjects;
